/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs } from 'antd';
import useQuery from '../../../util/useQuery';
import { useParams, useNavigate } from 'react-router-dom';
import { Sticky, StickyContainer } from 'react-sticky';
import Tab1 from './Tab1';
import Tab3 from './Tab3';
import Tab2 from './Tab2';
import { useEffect, useState } from 'react';
import RiskAssessmentService from '../../../services/RiskAssessment.service';
import { ROUTER } from '../../../constants/router';
import { t } from 'i18next';

const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
        {({ style }) => (
            <DefaultTabBar
                {...props}
                className="bg-white z-50"
                style={{
                    ...style,
                }}
            />
        )}
    </Sticky>
);

const RiskAssessmentDetailView = ({ getRiskAssessmentHeader }) => {
    const navigate = useNavigate();
    const { riskId } = useParams();
    const params = useQuery();
    const [detail, setDetail] = useState();
    const [mDefinition, setMDefinition] = useState([]);

    useEffect(() => {
        const getMDefinitions = async () => {
            const { data } = await RiskAssessmentService.getDefinitions();
            if (data.resultData) {
                setMDefinition(data.resultData);
            }
        };
        const getRiskDetail = async () => {
            const { data } =
                await RiskAssessmentService.getPublishRiskAssessmentDetail(
                    riskId
                );
            if (data.resultData) {
                setDetail(data.resultData);
            }
        };
        getMDefinitions();
        getRiskDetail();
        getRiskAssessmentHeader();
    }, []);

    return (
        <StickyContainer>
            <Tabs
                className="tabs"
                onChange={(key) =>
                    navigate(
                        `${ROUTER.RISK_MANAGEMENT.RR}/risk-assessment/${riskId}?tab=${key}`
                    )
                }
                activeKey={params.get('tab') || '1'}
                renderTabBar={renderTabBar}
            >
                <TabPane tab={t('RA.RiskFactor')} key={1}>
                    <Tab1 detail={detail} />
                </TabPane>
                <TabPane tab={t('RA.RiskMap')} key={2}>
                    <Tab2 detail={detail} definition={mDefinition} />
                </TabPane>
                <TabPane tab={t('RA.Likelihood')} key={3}>
                    <Tab3 detail={detail} definition={mDefinition} />
                </TabPane>
            </Tabs>
        </StickyContainer>
    );
};

export default RiskAssessmentDetailView;
